import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricHotelAverageLeadValueMicrosRateGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_hotel_average_lead_value_micros",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.hotelAverageLeadValueMicrosRate.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.hotelAverageLeadValueMicrosRate.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.hotelAverageLeadValueMicrosRate.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricHotelAverageLeadValueMicrosRateGhaPPA;
